(function () {
  var scrollSyncObserver = null;
  var scrollSyncScheduled = false;
  var scrollFallbackAttached = false;

  function isDesignMode() {
    return document.documentElement.classList.contains('shopify-design-mode');
  }

  function getBannersByPlacement(placement) {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-promo-placement="' + placement + '"]')
    );
  }

  function getVisibleBanner(placement) {
    return getBannersByPlacement(placement).find(function (banner) {
      return !banner.classList.contains('is-collapsed');
    });
  }

  function collapseTopSection(banner) {
    if (banner.dataset.promoPlacement !== 'top') return;

    var wrapper = banner.closest('.shopify-section, .promo-fixed-banner-top-section');
    if (wrapper) {
      wrapper.classList.add('promo-fixed-banner-top-section--collapsed');
    }
  }

  function collapseBannerGroup(element) {
    var group = element.dataset.dismissGroup;
    var targets = group
      ? Array.prototype.slice.call(document.querySelectorAll('[data-dismiss-group="' + group + '"]'))
      : [element];

    targets.forEach(function (banner) {
      banner.classList.remove('is-sticky-visible');
      banner.classList.add('is-collapsed');
      collapseTopSection(banner);
    });
  }

  function setHeaderStickyVisible(visible) {
    getBannersByPlacement('header').forEach(function (banner) {
      if (banner.classList.contains('is-collapsed')) return;

      if (visible) {
        banner.classList.add('is-sticky-visible');
      } else {
        banner.classList.remove('is-sticky-visible');
      }
    });
  }

  function initScrollSync() {
    if (isDesignMode()) return;

    var topBanner = getVisibleBanner('top');
    var headerBanner = getVisibleBanner('header');

    if (scrollSyncObserver) {
      scrollSyncObserver.disconnect();
      scrollSyncObserver = null;
    }

    if (!headerBanner) return;

    if (!topBanner) {
      setHeaderStickyVisible(true);
      return;
    }

    setHeaderStickyVisible(!isElementInViewport(topBanner));

    if (typeof IntersectionObserver === 'undefined') {
      if (!scrollFallbackAttached) {
        window.addEventListener('scroll', onScrollFallback, { passive: true });
        scrollFallbackAttached = true;
      }

      onScrollFallback();
      return;
    }

    scrollSyncObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== topBanner) return;
          setHeaderStickyVisible(!entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    scrollSyncObserver.observe(topBanner);
  }

  function isElementInViewport(element) {
    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function onScrollFallback() {
    var topBanner = getVisibleBanner('top');
    if (!topBanner) return;
    setHeaderStickyVisible(!isElementInViewport(topBanner));
  }

  function scheduleScrollSync() {
    if (scrollSyncScheduled) return;
    scrollSyncScheduled = true;

    requestAnimationFrame(function () {
      scrollSyncScheduled = false;
      initScrollSync();
    });
  }

  class PromoFixedBanner extends HTMLElement {
    connectedCallback() {
      this.closeButton = this.querySelector('[data-promo-close]');

      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.handleClose.bind(this));
      }

      scheduleScrollSync();
    }

    handleClose() {
      collapseBannerGroup(this);
      scheduleScrollSync();
    }
  }

  if (!customElements.get('promo-fixed-banner')) {
    customElements.define('promo-fixed-banner', PromoFixedBanner);
  }
})();
